import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X, ShieldCheck } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = sessionStorage.getItem('tusciahub_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem('tusciahub_cookie_consent', 'accepted');
    setIsVisible(false);
    window.location.reload();
  };

  const handleDecline = () => {
    sessionStorage.setItem('tusciahub_cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-[100] p-3 md:p-6 flex justify-center pointer-events-none">
      <div className="bg-white/95 backdrop-blur-xl border border-slate-200 p-5 rounded-3xl shadow-2xl max-w-2xl w-full pointer-events-auto animate-in slide-in-from-bottom duration-500 fade-in ring-1 ring-black/5">
        
        <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-start">
            
            {/* Icona Grande (Visibile SOLO su Desktop) */}
            <div className="hidden md:block bg-indigo-100 p-4 rounded-full text-indigo-600 shrink-0">
                <Cookie size={32} />
            </div>

            <div className="flex-grow w-full text-left">
                {/* Header Mobile Compatto */}
                <div className="flex justify-between items-start">
                    <h4 className="font-black text-slate-900 text-base md:text-lg mb-2 flex items-center gap-2">
                        {/* Icona Piccola (Solo Mobile) */}
                        <span className="md:hidden bg-indigo-100 p-1.5 rounded-lg text-indigo-600"><Cookie size={16}/></span>
                        Privacy & Cookie
                    </h4>
                    {/* X di chiusura (Mobile) */}
                    <button onClick={handleDecline} className="md:hidden text-slate-400 hover:text-slate-600 p-1 -mt-1 -mr-1">
                        <X size={20} />
                    </button>
                </div>

                <p className="text-slate-600 text-xs md:text-sm leading-relaxed mb-4 font-medium pr-2">
                    Usiamo cookie tecnici e analitici per migliorare il sito. 
                    <Link to="/privacy" className="text-indigo-600 underline hover:text-indigo-800 ml-1 whitespace-nowrap">Leggi Policy.</Link>
                </p>

                {/* Bottoni affiancati su mobile (risparmia spazio verticale) */}
                <div className="flex gap-3 w-full">
                    <button 
                        onClick={handleAccept}
                        className="flex-1 bg-slate-900 text-white px-4 py-3 rounded-xl font-bold text-xs md:text-sm hover:bg-indigo-600 transition shadow-lg shadow-indigo-500/20 flex items-center justify-center gap-2"
                    >
                        <ShieldCheck size={16}/> Accetta
                    </button>
                    <button 
                        onClick={handleDecline}
                        className="flex-1 bg-white border border-slate-200 text-slate-600 px-4 py-3 rounded-xl font-bold text-xs md:text-sm hover:bg-slate-50 transition"
                    >
                        Rifiuta
                    </button>
                </div>
            </div>

            {/* X di chiusura (Desktop) */}
            <button onClick={handleDecline} className="hidden md:block absolute top-4 right-4 text-slate-300 hover:text-slate-500 transition">
                <X size={20} />
            </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;